import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inventaire__left__accord-range" }
const _hoisted_2 = { class: "range" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "range__values" }
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = { class: "range__container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "range__track" }, null, -1)
const _hoisted_9 = ["min", "max", "step"]
const _hoisted_10 = ["min", "max", "step"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        style: {"display":"none"},
        id: _ctx.group+'ButtonReset',
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.resetSlider(true); _ctx.refreshFilter();})
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "range__position",
          onDblclick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetSlider(true)))
        }, [
          _createElementVNode("input", {
            type: "money",
            id: _ctx.group+'MinLayout',
            value: _ctx.group != 'year' ? Number(_ctx.minValue).toLocaleString(_ctx.locale) : _ctx.minValue,
            readonly: ""
          }, null, 8, _hoisted_5),
          _createTextVNode(" " + _toDisplayString(_ctx.state.jsonFile['filtre']['range']) + " ", 1),
          _createElementVNode("input", {
            type: "money",
            id: _ctx.group+'MaxLayout',
            value: _ctx.group != 'year' ? Number(_ctx.maxValue).toLocaleString(_ctx.locale) : _ctx.maxValue,
            readonly: ""
          }, null, 8, _hoisted_6)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", {
          ref: "{range}",
          class: "range__track range__track-set",
          style: _normalizeStyle('margin-left: '+_ctx.startLayout+'%;width: '+_ctx.widthLayout+'%')
        }, null, 4),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: _ctx.min,
          max: _ctx.max,
          step: _ctx.step,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.minValue) = $event)),
          onDblclick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetSlider(true))),
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args))),
          onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args))),
          onDrag: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args)))
        }, null, 40, _hoisted_9), [
          [_vModelText, _ctx.minValue]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: _ctx.min,
          max: _ctx.max,
          step: _ctx.step,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.maxValue) = $event)),
          onDblclick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetSlider(true))),
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args))),
          onMousedown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args))),
          onDrag: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateSlider && _ctx.updateSlider(...args)))
        }, null, 40, _hoisted_10), [
          [_vModelText, _ctx.maxValue]
        ])
      ])
    ])
  ]))
}